export class InsufficientBalanceError extends Error {
  constructor(message = 'Insufficient Balance') {
    super(message);
    this.message = message;
    this.name = 'InsufficientBalanceError';
  }
}

export class StakingPoolExpiredError extends Error {
  constructor(message = 'Staking Pool Expired') {
    super(message);
    this.message = message;
    this.name = 'StakingPoolExpiredError';
  }
}

export class ExceedingMaxLimitsError extends Error {
  constructor(message = 'Exceeding Max Limits') {
    super(message);
    this.message = message;
    this.name = 'ExceedingMaxLimitsError';
  }
}
